import { InjectionToken } from '@angular/core';

export const LAZY_MODULES = new InjectionToken<{ [key: string]: string }>('LAZY_MODULES');
